export default {
  lang: {
    reset: 'Sıfırla',
    search: 'Tarama',
    expand: 'Genişler',
    collapse: 'Kal onu.',
  },
};
